



































import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class MembershipLogo extends Vue {
  @Prop({ default: "" }) readonly membershipStatus!: string;
}
